/**
 * Safely parse JSON strings with error handling
 * @param jsonString - The string to parse
 * @param fallbackValue - Value to return if parsing fails
 * @returns Parsed object or fallback value
 */
export const safeJsonParse = <T = any>(
  jsonString: any,
  fallbackValue: T | null = null,
): T | null => {
  try {
    // If it's not a string, return fallback
    if (typeof jsonString !== 'string') {
      console.warn('safeJsonParse: Expected string, got', typeof jsonString);
      return fallbackValue;
    }

    return JSON.parse(jsonString);
  } catch (error) {
    console.warn('Failed to parse JSON:', error, 'Input:', jsonString);
    return fallbackValue;
  }
};

/**
 * Safely stringify objects to JSON
 * @param obj - Object to stringify
 * @param fallbackValue - Value to return if stringification fails
 * @returns JSON string or fallback value
 */
export const safeJsonStringify = (obj: any, fallbackValue: string): string => {
  try {
    return JSON.stringify(obj);
  } catch (error) {
    console.warn('Failed to stringify to JSON:', error);
    return fallbackValue;
  }
};
